import { Step } from "./Step";
import { StepTypes } from "../../enum/StepTypes";
import { ICallReference } from "../../interfaces/IReference";
import { MultiLanguage } from "../../MultiLanguage";
export class ProcessInfoStep extends Step {
    private _turnTypes: number[];
    private _hasMultiLanguageExams: boolean;
    private _references: ICallReference[];

    constructor(step: any) {
        super(step);
        if (step.turnTypes.length) {
            this._name = StepTypes.translations[step.type].name;
        }else{
            this._name = StepTypes.translations[step.type].alterName;
        }
        this._turnTypes = step.turnTypes;
        this._hasMultiLanguageExams = step.hasMultiLanguageExams;
        this._references = step.references && step.references.length 
            ? step.references.map(ref => {
                return {
                    ... ref, 
                    description: new MultiLanguage(ref.description),
                    order: null,
                    selected: false
                }
            }) 
            : [];
    }

    public get turnTypes(): number[] {
        return this._turnTypes;
    }

    public get hasMultiLanguageExams(): boolean {
        return this._hasMultiLanguageExams;
    }

    public get references(): ICallReference[] {
        return this._references;
    }

    public set references(references: ICallReference[]) {
        this._references = references;
    }

    public getReferencesOnTurn(): {turn: number, referencesOnTurn: number}[] {
        return this._turnTypes.length > 0 ?
            this._turnTypes.map((turnType) => {
                return {
                    turn: turnType,
                    referencesOnTurn: this.getReferencesByTurn(turnType)
                }
            }) : [];
    }

    private getReferencesByTurn(turn: number): number {
        return this._references.filter(refs => refs.turn === turn).length;
    }
}